import styled from 'styled-components';
import PhoneInputTheme
  from '@shipae/components-sandbox/component/phone-input/theme/shipa-ecommerce'; // eslint-disable-line max-len

export const CustomPhoneInputTheme = {
  ...PhoneInputTheme,
  Main: styled(PhoneInputTheme.Main)`
    &:after {
      top: calc(5.6rem - 1px);
      bottom: unset;
      height: 1px;
    }
  `,
  SelectContainer: styled(PhoneInputTheme.SelectContainer)`
    flex-basis: 10rem;
  `,
};
